<div class="sidebar">
  <div class="sidebar-logo">
    <img src="assets/img/company1/buupass_full_logo100X40.png" alt="BuuPass">
  </div>

  <div class="sidebar-user-card">
    <div class="sidebar-avatar">{{ (user?.first_name || user?.fullName || user?.email || 'A').charAt(0) | uppercase }}</div>
    <div class="sidebar-user-info">
      <strong class="sidebar-user-name">{{ user?.fullName || 'Traveller' }}</strong>
      <span class="sidebar-user-phone">{{ user?.phone_number || user?.email }}</span>
    </div>
  </div>

  <nav class="sidebar-nav">
    <a class="sidebar-nav-item" [class.active]="activeTab === 'profile'"
       (click)="navigateTo('profile', $event)" href="#">
      <span class="sidebar-nav-icon sidebar-nav-icon-svg" aria-hidden="true">
        <svg viewBox="0 0 24 24" focusable="false">
          <path d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4Zm0 2c-3.3 0-6 1.8-6 4v1h12v-1c0-2.2-2.7-4-6-4Z" fill="currentColor"/>
        </svg>
      </span>
      Profile
    </a>
    <a class="sidebar-nav-item" [class.active]="activeTab === 'trips'"
       (click)="navigateTo('trips', $event)" href="#">
      <span class="sidebar-nav-icon"><i class="fa fa-bus"></i></span>
      My Trips
    </a>
    <a class="sidebar-nav-item" [class.active]="activeTab === 'login'"
       (click)="navigateTo('login', $event)" href="#">
      <span class="sidebar-nav-icon"><i class="fa fa-lock"></i></span>
      Login Details
    </a>
    <a class="sidebar-nav-item" [class.active]="activeTab === 'devices'"
       (click)="navigateTo('devices', $event)" href="#">
      <span class="sidebar-nav-icon"><i class="fa fa-desktop"></i></span>
      Devices
    </a>
  </nav>
</div>

<div class="mobile-topbar">
  <div class="mobile-topbar-left">
    <div class="sidebar-avatar mob-avatar">{{ (user?.first_name || user?.fullName || user?.email || 'A').charAt(0) | uppercase }}</div>
    <div class="sidebar-user-info">
      <strong class="sidebar-user-name">{{ user?.fullName || 'Traveller' }}</strong>
      <span class="sidebar-user-phone">{{ user?.phone_number || user?.email }}</span>
    </div>
  </div>
  <a class="mob-signout" href="#" (click)="logoutUser(); $event.preventDefault()">
    <i class="fa fa-sign-out"></i> Sign out
  </a>
</div>

<nav class="mobile-bottom-nav">
  <a class="mob-nav-item mob-nav-item-account" [class.active]="activeTab === 'profile'"
     (click)="navigateTo('profile', $event)" href="#">
    <span class="mob-nav-icon mob-nav-icon-svg" aria-hidden="true">
      <svg viewBox="0 0 24 24" focusable="false">
        <path d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4Zm0 2c-3.3 0-6 1.8-6 4v1h12v-1c0-2.2-2.7-4-6-4Z" fill="currentColor"/>
      </svg>
    </span>
    <span class="mob-nav-label">Account</span>
  </a>
  <a class="mob-nav-item" [class.active]="activeTab === 'trips'"
     (click)="navigateTo('trips', $event)" href="#">
    <i class="fa fa-bus mob-nav-icon"></i>
    <span class="mob-nav-label">Trips</span>
  </a>
  <a class="mob-nav-item" [class.active]="activeTab === 'devices'"
     (click)="navigateTo('devices', $event)" href="#">
    <i class="fa fa-desktop mob-nav-icon"></i>
    <span class="mob-nav-label">Devices</span>
  </a>
  <a class="mob-nav-item" [class.active]="activeTab === 'login'"
     (click)="navigateTo('login', $event)" href="#">
    <i class="fa fa-lock mob-nav-icon"></i>
    <span class="mob-nav-label">Security</span>
  </a>
</nav>
